const message = {
    addText: "添加",
    addSomeThing: "添加{label}",
    delText: "删除",
    selectedTextAdvanced: "已选",
    delConfirm: "确定要删除这条{name}吗?",
    defaultInputPlaceholder: "请输入{label}",
    defaultSelectPlaceholder: "请选择{label}",
    startDate: "开始日期",
    endDate: "结束日期",
    soFarText: "至今",
    uploadButtonText: "点击上传",
    uploadTips: "支持扩展名{extensionNames},单个文件大小不超过{fileSize}M，最多上传{maxLength}个附件",
    yuan: "元",
    thousand: "万元",
    salaryType: "薪资类型",
    Cancel: "取消",
    Save: "保存",
    Next: "下一步",
    Complete: "完成",
    Crop: "裁剪",
    Preview: "预览",
    PictureFormat: "图片格式：",
    ImageSize: "图片尺寸：",
    ReUpload: "重新上传",
    UploadFailed: "上传失败{msg}",
    NotExceeding: "不超过{size}M",
    FileNotExceeding: "文件{name}不能超过{size}MB!",
    Rotate: "旋转",
    ImageFull: "充满",
    Size: "大小",
    Sign: "签名",
    ClickSign: "点击签名",
};

export default message;
